<template lang="pug">
.profile.mx-6
   loader(:showLoader="show")
   .container.mx-auto.mb-8.text-left.max-w-md
      .mt-4
         label.settings-input-label Name
         input.settings-input(v-model='user.name', placeholder='Name')
      .mt-4
         label.settings-input-label Google Account
         input.settings-input(v-model='user.email', placeholder='Google Email', :placeholder="user.email" disabled)
      .mt-6
          label.settings-input-label(for='account') Date format
          .relative
            select#account.settings-select(v-model='user.settings.dateformat')
                option(value='L') {{ new Date() | moment("L") }}
                option(value='DD/MM/YYYY') {{ new Date() | moment("DD/MM/YYYY") }}
                option(value='ll') {{ new Date() | moment("ll") }}
                option(value='DD/MM/YY') {{ new Date() | moment("DD/MM/YY") }}
                option(value='DD/MM') {{ new Date() | moment("DD/MM") }}
                option(value='MM/DD') {{ new Date() | moment("MM/DD") }}
            .select-icon-wrap
                .select-icon
      .mt-4
         label.settings-input-label Time offeset
         .relative
            select#account.settings-select(v-model='user.settings.timeoffset')
               option(v-for="hours in timeoffset" :value='hours.offset') {{ hours.display }} h
            .select-icon-wrap
               .select-icon
      .mt-4
         button.btn.btn-primary.btn-sm(@click="updateUser") Update
</template>
<script>
import axios from 'axios'
import Loader from '@/components/modules/Loader'

export default {
  name: 'profile',
  components: {
    Loader,
    axios
  },
  created () {
    this.show = true
    for (let i = 1; i <= 12; i++) {
      this.timeoffset.push({ display: i, offset: i })
    }
    for (let i = 1; i <= 12; i++) {
      this.timeoffset.push({ display: '-' + i, offset: i * -1 })
    }
    axios.get(`user`).then((user) => {
      this.show = false
      user.data.settings = user.data.settings || {}
      user.data.dateformat = user.data.dateformat || 'L'
      if (user.data.subscription && user.data.subscription.status === 'active') this.subscribed = true
      this.user = user.data
    })
  },
  data () {
    return {
      show: false,
      user: {
        settings: {}
      },
      timeoffset: []
    }
  },
  methods: {
    updateUser () {
      this.show = true
      axios.put(`user`, this.user).then((user) => {
        axios.get(`user`).then((user) => {
          this.show = false
          user.data.settings = user.data.settings || {}
          this.user = user.data
        })
      })
    }
  }
}
</script>

<style >
.gmail input {
      outline: none;
      color: #34495e;
  }
.gmail label {
     font-size: 0.6rem !important;
      color: #2CE8B5 !important;
      font-weight: 600 !important;
      text-transform: uppercase;
      top: -0.6rem !important;
      left: 0 !important;
 }

.toggle-label {
   margin-left:.5rem;
}
.mt-20 {
   margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue